/**
 * UranIA PA — `/trasparenza-ia` (disclosure AI Act art. 50, versione pagina).
 *
 * Pagina istituzionale nuova (Riordino della mappa delle rotte §3/§4,
 * Rilascio A passo A.7). Il testo riusa parola per parola
 * `ai_disclosure.banner_long` — lo stesso già live nel banner sticky
 * globale (`components/disclosure/AiDisclosureBanner.tsx`) e già
 * verificato/approvato: nessun nuovo testo legale inventato qui, solo
 * la stessa disclosure in forma di pagina permanente e linkabile.
 */

import { useTranslation } from 'react-i18next';
import { createRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { InstitutionalPageShell } from '../features/sistema/InstitutionalPageShell.tsx';
import { Route as PubblicoRoute } from './_pubblico.tsx';

function TrasparenzaIaPage(): JSX.Element {
  const { t } = useTranslation();
  return (
    <InstitutionalPageShell
      badge={t('istituzionale.trasparenza_ia.badge')}
      title={t('istituzionale.trasparenza_ia.title')}
      testId="trasparenza-ia-page"
    >
      <p>{t('istituzionale.trasparenza_ia.body')}</p>
      <a
        href="https://www.normattiva.it/eli/id/2025/09/24/25G00138/sg"
        rel="noreferrer noopener external"
        target="_blank"
        data-testid="trasparenza-ia-link-legge-132"
      >
        {t('istituzionale.trasparenza_ia.link_legge_132')}
      </a>
    </InstitutionalPageShell>
  );
}

export const Route = createRoute({
  getParentRoute: () => PubblicoRoute,
  path: '/trasparenza-ia',
  component: TrasparenzaIaPage,
});
